









import VueOptions from '@utils/VueOptions'
import AlertBar from '@components/AlertBar'

settings =
  vue:
    name: 'EventAlertBar'
    props: ['event']
    components: { AlertBar }
    methods: 
      alert: () ->
        # return @promptToSubmitOffer() if true
        return null
      promptToSubmitOffer: ->
        {
          id: @event.id
          type: 'info'
          message: "Organizer is waiting. Submit your offer!"
          button: { label: 'View Offers', nav: { params: { tab: 'offers' } } } 
          dismissable: false
        }
export default VueOptions.vue settings
